import React, { useEffect, useState } from 'react';
import { Routes, Route , Navigate, useLocation } from 'react-router-dom';
import Login from './components/Login/Login';
import Main from './components/Main/Main';
import NotFound from './components/Utility/NotFound';
import Header from './components/Header';
import Nav from './components/Nav';
import Notice from './components/About/Notice';
import Estimate from './components/Reservation/Estimate';
import Reservation from './components/Reservation/Reservation';
import ReservationDetail from './components/Reservation/ReservationDetail';
import ShoppingBag from './components/Point/ShoppingBag';
import PointCharge from './components/Point/PointCharge';
import PointDetail from './components/Point/PointDetail';
import Community from './components/Community/Community';
import CommunityDetail from './components/Community/CommunityDetail';
import CommunityFavorite from './components/Community/CommunityFavorite';
import FAQ from './components/About/FAQ';
import QNA from './components/About/QNA';
import Footer from './components/Footer';
import Spinner from './components/Utility/Spinner';
import { useSelector } from 'react-redux';
import { RootState } from './redux/Store';
import ReservationSuccess from './components/Reservation/ReservationSuccess';
import PostPortfolio from './components/Community/PostPortfolio';
import { MainAppContainer } from './style/StyleComponentMain';
import Payment from './components/Reservation/Payment';
import PaymentSuccess from './components/Reservation/PaymentSuccess';
import ModifyPortfolio from './components/Community/ModifyPortfolio';
import PortfolioSelectOne from './components/Community/PortfolioSelectOne';
import ReservationSelectOne from './components/Reservation/ReservationSelectOne';
import PostQna from './components/About/PostQna';
import QNASelectOne from './components/About/QNASelectOne';
import NoticeSelectOne from './components/About/NoticeSelectOne';
import PrivacyPolicy from './components/About/PrivacyPolicy';
import TermsOfService from './components/About/TermsOfService';

const App:React.FC = () => {
  const spinner = useSelector((state: RootState) => state.commonData.spinner);
  const locationHook = useLocation();
  const [currentLastUrl, setCurrentLastUrl] = useState<string | null>('');

  useEffect(() => {
    const splitUrl = locationHook?.pathname?.split('/') ?? null;
    const location: string | null = splitUrl?.length > 1 ? splitUrl[splitUrl.length -1] : null;
    setCurrentLastUrl(location);
  }, [currentLastUrl, locationHook]);

  useEffect(() => {
    window.localStorage.setItem('update_nav_switch', 'false');
  }, []);

  // useEffect(() => {
  //   console.log(positionY);
  // }, [positionY]);

  const offNavModal = () => {};

  return (
    <div>
      {spinner && <Spinner />}
      {/* Main Header */}
      {(
        currentLastUrl === 'login' ||
        currentLastUrl === 'privacy_policy_no_session' ||
        currentLastUrl === 'terms_of_service_no_session'
      ) || <div><Header /></div>}
      {/* Main Header */}

      <div className='flex w-[100%]'>

        {/* 사이드 네브바 */}
        {(
          currentLastUrl === 'login' ||
          currentLastUrl === 'privacy_policy_no_session' ||
          currentLastUrl === 'terms_of_service_no_session'
        ) || 
          <div className='hidden 2xl:block 2xl:fixed'><Nav offNavModal={offNavModal} /></div>
        }

        <MainAppContainer className={`${currentLastUrl === 'login' ? "mt-0" : "mt-[70px] 2xl:ml-[360px]" } ${currentLastUrl === 'main' && "bg-lightGray02"}`} $borderWidth={currentLastUrl === 'login' || currentLastUrl === 'main' ? "0" : "20px"}>
          {/* Content Section */}
          <div className={`${currentLastUrl === 'login' || currentLastUrl === 'main' ? "max-w-[100%]" : "max-w-[1080px]" } w-[100%] flex justify-center`}>
            <Routes>
                {/* 로그인, 메인 페이지 */}
                <Route path='/' element={<Navigate to="/login" />} />
                <Route path='/login' element={<Login />} />
                <Route path='/main' element={<Main />} />

                {/* 견적계산기, A.Black 서비스예약, 예약 내역 */}
                <Route path='/estimate' element={<Estimate />} />
                <Route path='/reservation' element={<Reservation />} />
                <Route path='/reservation_detail' element={<ReservationDetail />} />
                <Route path='/reservation_success' element={<ReservationSuccess />} />
                <Route path='/reservation_select_one' element={<ReservationSelectOne />} />
                <Route path='/payment_success' element={<PaymentSuccess />} />

                {/* 결제하기 */}
                <Route path='/payment' element={<Payment />} />

                {/* 견적 장바구니, AP포인트 충전, AP포인트 내역 */}
                <Route path='/shopping_bag' element={<ShoppingBag />} />
                <Route path='/point_charge' element={<PointCharge />} />
                <Route path='/point_detail' element={<PointDetail />} />

                {/* 커뮤니티, 커뮤니티 작성 내역, 커뮤니티 즐겨찾기 */}
                <Route path='/community' element={<Community />} />
                <Route path='/community_detail' element={<CommunityDetail />} />
                <Route path='/community_favorite' element={<CommunityFavorite />} />
                <Route path='/post_portfolio' element={<PostPortfolio />} />
                <Route path='/modify_portfolio' element={<ModifyPortfolio />} />
                <Route path='/portfolio_select_one' element={<PortfolioSelectOne />} />

                {/* 공지사항, FAQ, 1:1 문의 */}
                <Route path='/notice' element={<Notice />} />
                <Route path='/notice_select_one' element={<NoticeSelectOne />} />
                <Route path='/faq' element={<FAQ />} />
                <Route path='/qna' element={<QNA />} />
                <Route path='/post_qna' element={<PostQna />} />
                <Route path='/qna_select_one' element={<QNASelectOne />} />

                {/* 정책 */}
                <Route path='/privacy_policy' element={<PrivacyPolicy />} />
                <Route path='/terms_of_service' element={<TermsOfService />} />

                <Route path='/privacy_policy_no_session' element={<PrivacyPolicy />} />
                <Route path='/terms_of_service_no_session' element={<TermsOfService />} />
                
                {/* 잘못된 URL */}
                {/* <Route path='/*' element={<Navigate to="/notfound" />} /> */}
                <Route path='/*' element={<NotFound />} />
            </Routes>
          </div>
          {/* Content Section */}
        </MainAppContainer>
      </div>

      {(
          currentLastUrl === 'login' ||
          currentLastUrl === 'privacy_policy_no_session' ||
          currentLastUrl === 'terms_of_service_no_session'
        ) || <Footer />}
    </div>
  );
}

export default App;
